<template>
  <v-card>
    <v-img
      src="static/data/wnstr-reise/Haus-der-Deutschen-Weinstrasse.jpg"
      aspect-ratio="1.5"
    ></v-img>

    <v-card-title primary-title class="wsr-text">
      <span class="wsr-start-credit">
        Foto: &copy;Verbandsgemeinde Grünstadt-Land (via
        <a href="https://commons.wikimedia.org/wiki/File:Haus-der-Deutschen-Weinstrasse.jpg">Wikimedia Commons</a>)
      </span>
      <div>
        <h3 class="headline mb-0 wsr-title">Weinstraßenreise</h3>
        <div>
          Eine interaktive Reise entlang der Deutschen Weinstraße:
          von Bockenheim bis nach Schweigen.
        </div>
        <p v-if="!isMobile" class="wsr-start-instr">
          Fahren Sie mit der Maus über die <img src="static/data/wnstr-reise/vineyard-white.png" alt="" />-Icons,
          um sich den Ortsnamen anzeigen zu lassen.
        </p>
        <p class="wsr-start-instr">
          Für weitere Detail-Informationen zu einem Ort Ihres Interesses klicken / tippen Sie auf das
          <img src="static/data/wnstr-reise/vineyard-white.png" alt="" />-Icon.
        </p>
      </div>
    </v-card-title>

    <v-card-actions v-if="isMobile">
      <v-btn flat color="gray" @click="showMe=false">Zur Karte</v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>

import { WguEventBus } from '../../src/WguEventBus';
import { Device } from '../util/Device';

export default {
  name: 'wsr-startscreen',
  components: {
  },
  props: {
  },
  data () {
    return {
      showMe: true
    }
  },
  computed: {
    isMobile () {
      return Device.isMobile();
    }
  },
  watch: {
    showMe (val) {
      if (val === false) {
        WguEventBus.$emit('wsr-sidebar-hide');
      }
    }
  }
};

</script>

<style scoped>

  a {
    color: inherit !important;
  }
  .wsr-start-credit {
    font-size:smaller;
    margin-top: -15px;
  }
  .wsr-title {
    margin-top: 20px;
  }
  .wsr-start-instr {
    margin-top: 20px;
  }
  .wsr-start-instr img {
    vertical-align: middle;
  }


</style>



// WEBPACK FOOTER //
// app/components/Startscreen.vue